import React, { useState, useEffect } from "react";
import "./intakeForm.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { authenticatedFetch } from "../../network/api";
import InputField from "../../components/input/inputField";
import DocumentUpload from "../../components/input/documentUpload";
import SearchHeader from "../searchResults/searchHeader";

const IntakeForm = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  const location = useLocation(); // Get the location (URL)
  const navigate = useNavigate(); // Hook to navigate after form submission
  const client = useSelector((state) => state.clientData.clientData);

  // Extract query parameters using URLSearchParams
  const queryParams = new URLSearchParams(location.search);
  const lawyerId = queryParams.get("lawyerId");
  const lawyerName = queryParams.get("lawyerName");
  const priceId = queryParams.get("priceId");
  const productId = queryParams.get("productId");
  const accountId = queryParams.get("accountId");
  const date = queryParams.get("date");
  const startTime = queryParams.get("startTime");
  const endTime = queryParams.get("endTime");
  const profilePhotoURL = queryParams.get("lawyerProfilePhoto");
  const price = queryParams.get("price");
  const practiceAreas = queryParams.get("practiceAreas");
  const firmId = queryParams.get("firmId");
  const appointmentTypeId = queryParams.get("appointmentTypeId");
  const appointmentName = queryParams.get("appointmentName");
  const lawyerPhoto = queryParams.get("lawyerPhoto");
  const duration = queryParams.get("duration");

  const formatLocalTime = (utcTimeStr) => {
    const utcDate = new Date(`1970-01-01T${utcTimeStr}Z`);
    return utcDate.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
    });
  };

  const handleFileSelect = (urls) => {
    setFiles(urls);
    console.log("Uploaded files: ", urls);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create appointment request data
    const appointmentData = {
      userId: client.user_id,
      lawyerId,
      firmId: firmId, // Assuming firmId is the accountId from query params
      appointmentTypeId: appointmentTypeId, // Assuming priceId corresponds to appointment type
      dateTime: {
        date: date,
        time: startTime,
      },
      documents: files, // The files uploaded
      meetingNotes: message,
      status: "pending", // Default status
      duration: duration,
    };

    try {
      setUploading(true);

      // Call the API endpoint to create the appointment request
      const response = await authenticatedFetch(
        "/api/client/webapp/createAppointmentRequest",
        {
          method: "POST",
          body: JSON.stringify(appointmentData),
        }
      );

      const data = await response.json();
      if (response.ok) {
        // If appointment creation was successful, navigate to the checkout page with query params
        const navigateToCheckout = `/client/checkout?lawyerId=${lawyerId}&lawyerName=${lawyerName}&priceId=${priceId}&productId=${productId}&accountId=${accountId}&date=${date}&startTime=${startTime}&endTime=${endTime}&price=${price}&practiceAreas=${practiceAreas}&appointmentName=${appointmentName}&requestId=${data.data.id}&lawyerPhoto=${lawyerPhoto}`;
        navigate(navigateToCheckout); // Navigate to the checkout form page with the parameters
      } else {
        console.error("Failed to create appointment:", data.error);
        alert("Failed to create appointment. Please try again.");
      }
    } catch (error) {
      console.error("Error in submitting appointment:", error);
      alert("Error submitting the appointment request. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <SearchHeader searchBar={false} headerColor="search-header-gray" />
      <div className="appointment-form">
        <div className="service-details">
          <div className="service-header">
            <img
              src={profilePhotoURL}
              alt="Lawyer"
              className="profile-photo-intake"
            />
            <div className="service-info">
              <h2>{lawyerName}</h2>
              <p className="practice-area-intake">{practiceAreas || "N/A"}</p>
              <p className="appointment-time">
                {date}, {formatLocalTime(startTime)} -{" "}
                {duration ? `${duration} mins` : "N/A"}
              </p>
              <p className="total-amount">Total Amount: ${price}</p>
            </div>
          </div>
        </div>

        <InputField
          title="Email"
          placeholder="johnappleseed@quidpro.ai"
          isRequired={true}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input-spacing"
        />

        <InputField
          title="Full Legal Name"
          placeholder={client.name}
          isRequired={true}
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="input-spacing"
          disabled
        />

        <div className="form-field">
          <label>
            Any specific topics or issues you wish to discuss during the
            appointment?
          </label>
          <textarea
            style={{ width: "600px" }}
            name="message"
            rows="4"
            required
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>

        <DocumentUpload
          title="Upload Appointment Documents"
          userId={client.user_id}
          lawyerId={lawyerId}
          onFileSelect={handleFileSelect}
        />

        <button
          className="continue-btn"
          onClick={handleSubmit}
          disabled={uploading}
        >
          {uploading ? "Submitting..." : "Continue"}
        </button>
      </div>
    </div>
  );
};

export default IntakeForm;
